import type { Discount } from '@carvana/merch-contracts';
import DiscountType from '@carvana/merch-contracts/DiscountType';
import { useMemo } from 'react';
import { useConfiguration } from '~/context/common/StaticContext';
import { useInventoryVehicles } from '~/context/srp/InventoryContext';

export default function useGetGeicoDiscount(): Discount | null {
  const { enableGeicoDiscount = false } = useConfiguration();
  const vehicles = useInventoryVehicles();

  return useMemo<Discount | null>(
    () =>
      enableGeicoDiscount
        ? vehicles
            .at(0)
            ?.price?.discounts?.find(
              discount => discount.type === DiscountType.GeicoTotalLoss
            ) ?? null
        : null,
    [enableGeicoDiscount, vehicles]
  );
}
